<template>
    <div>
        <div class="relative">
            <img class="banner" :src="setting.image"/>
            <div class="main-width absolute py-5 bread">
                <VBreadcrumb theme="white" :options="[{ label: '首页', to: '/' }, {label: setting.name}]"></VBreadcrumb>
            </div>
            <div class="title">
                <h1>{{ setting.name }}</h1>
                <h2>{{ setting.name_en }}</h2>
            </div>
        </div>
        <section class="content">
            <div class="main-width">
                <div class="flex tab">
                    <div class="tab-item" :class="{active:tabIndex == 0}" @click="toggleTab(0)">综合须知</div>
                    <div class="tab-item" :class="{active:tabIndex == 1}"  @click="toggleTab(1)">品牌公司相关须知</div>
                </div>
                <VSticky :offsetTop="appHeaderHeight" @change="isFixedScrollNav = $event" v-if="tabIndex == 1">
                    <div class="scroll-nav-affix" :class="[{'scroll-nav-affix-fixed': isFixedScrollNav}]" ref="scrollNavRef">
                        <scroll-active class="scroll-nav" tag="ul" :offset="offsetTop">
                            <li class="company scrollactive-item" v-for="(item,index) in companys" :key="item.id" :data-section-selector="'#com-'+item.id" @click="companClick(index)">{{ item.company }}</li>
                        </scroll-active>
                    </div>
                </VSticky>
                <transition-group tag="div" enter-active-class="animate__animated animate__fadeIn" v-if="tabIndex == 1">
                    <div class="collapse" :id="'com-'+item.id" v-for="(item,index) in companys" :key="item.id">
                        <div class="item" @click="toggleStatus(index,'statusCompany')">
                            <div class="question">{{ item.company }}</div>
                            <div class="status">
                                {{ statusCompany[index] ? '收起' : '展开' }}
                                <span class="arrow" :class="{ rotateUp: statusCompany[index], rotateDown: !statusCompany[index] }">
                                    <i class="ficon ficon-arrow-bottom"></i>
                                </span>
                            </div>
                        </div>
                        <el-collapse-transition>
                            <div class="answer-box" v-if="statusCompany[index]">
                                <div class="answer" v-html="item.content"></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                </transition-group>
                <div v-else>
                    <scroll-active class="hidden" tag="ul" :offset="appHeaderHeight">
                        <li class="company scrollactive-item" v-for="item in questions" :key="item.id" :data-section-selector="'#qu-'+item.id">{{ item.title }}</li>
                    </scroll-active>
                    <div class="collapse a" key="a" v-for="(item,index) in questions" :key="item.id" :id="'qu-'+item.id">
                        <div class="item" @click="toggleStatus(index,'status')">
                            <div class="question">{{ item.title }}</div>
                            <div class="status">
                                {{ status[index] ? '收起' : '展开' }}
                                <span class="arrow" :class="{ rotateUp: status[index], rotateDown: !status[index] }">
                                    <i class="ficon ficon-arrow-bottom"></i>
                                </span>
                            </div>
                        </div>
                        <el-collapse-transition>
                            <div class="answer-box" v-if="status[index]">
                                <div class="answer" v-html="item.content"></div>
                            </div>
                        </el-collapse-transition>
                    </div>
                </div>
                <!-- <div class="text-center pt-5">
                    <el-button class="btn-more">查看更多信息</el-button>
                </div> -->
            </div>
        </section>
    </div>
</template>
<script>
import VBreadcrumb from '@/components/VBreadcrumb.vue'
import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VSticky from '~/components/VSticky/index.vue'
import useLayout from '~/composables/useLayout'
import {useElementSize} from "@vueuse/core";
import ScrollActive from "@/components/ScrollActive";
import { getNotice } from '@/services/company'
import {
  defineComponent,
  ref,
  computed,
  useRoute,
  useMeta
} from "@nuxtjs/composition-api";

export default defineComponent({
    name:'instructions',
    layout: 'Main',
    head: {
        title: '邮轮须知'
    },
    auth:false,
    components:{VBreadcrumb,ElCollapseTransition,VSticky,ScrollActive},
    setup(){
        const scrollNavRef = ref();
        const { headerSize } = useLayout();
        const {height: scrollNavHeight} = useElementSize(scrollNavRef)

        const offsetTop = computed(() => headerSize.height + scrollNavHeight.value + 7);
        const appHeaderHeight = computed(() => headerSize.height);
        const isFixedScrollNav = ref(false);
        const route = useRoute()
        const tabIndex = ref(route.value.query.tab || 0)
        
        useMeta({
            title: "上船吧邮轮综合须知,邮轮品牌公司须知,了解什么是邮轮旅游,什么人适合乘坐邮轮",
            meta: [
                {
                name: "description",
                content:
                    "上船吧邮轮平台为您提供综合须知,邮轮公司须知,了解相关邮轮乘坐问题",
                hid: "description",
                }, 
                {
                name: "keywords",
                hid: "keywords",
                content: "邮轮综合须知,邮轮公司须知,什么是邮轮旅游,邮轮旅游很贵么,皇家加勒比邮轮公司须知,爱达邮轮须知",
                },
            ],
        });

        return {
            appHeaderHeight,
            isFixedScrollNav,
            offsetTop,
            scrollNavRef,
            tabIndex,
        }
    },
    data(){
        return {
            status: {
                '0': true
            },
            statusCompany:{
                '0': true
            },
            companys:[],
            questions:[],
            setting:{}
        }
    },
    methods:{
        toggleStatus(index,key) {
            if (this[key][index]) {
                this.$set(this[key], index, !this[key][index])
            } else {
                this.$set(this[key], index, true)
            }
        },
        toggleTab(index){
            this.tabIndex = index
            this.$router.replace({
				query: {
					tab:index
				}
			});
        },
        async noticeFunc(){
            const { data, code, msg } = await getNotice()
            if (code === 10000 || code === 200) {
				this.questions = data.synthesize
                this.companys = data.brand
                const compStatus = []
                this.companys.forEach((_,index)=>{
                    compStatus.push({
                        [index]:true
                    })
                })
                this.statusCompany = compStatus
                this.setting = {
                    image:data.image,
                    name:data.name,
                    name_en:data.name_en
                }
                
			} else {
				this.$message({
					type: "error",
					text: msg
				});
			}
        },
        companClick(index){
            this.$set(this.statusCompany,index,true)
        },
    },
    async fetch(){
        await this.noticeFunc()
    },
    watch:{
        questions(v){
            if(v && v.length && this.tabIndex == 0){
                const qid = this.$route.hash.replace('#qu-','')
                const index = v.findIndex(item=>item.id == qid)
                this.$set(this.status,index,true)
            }

        }
    }
})
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 280px;
  display: block;
  object-fit: cover;
}
.title {
  text-align: center;
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding-top: 85px;
}
.title h1 {
  font-size: 52px;
  font-weight: 500;
  margin-bottom: 4px;
}
.title h2 {
  font-size: 26px;
}
.bread {
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
}
.content {
  padding: 40px 0 124px 0;
  background-color: #fff;
}
.content .tab {
  font-size: 18px;
  margin-bottom: 20px;
}
.content .tab-item {
  background-color: $color-grey-20;
  padding: 16px 34px;
  margin-right: 6px;
  border-radius: 4px;
  color: $color-black-2;
  cursor: pointer;
}
.content .tab-item.active {
  background-color: $color-black-2;
  color: #fff;
}
.content .tab-item:not(.active):hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.content .company {
  margin-right: 7px;
  margin-bottom: 7px;
  width: 165px;
  height: 50px;
  font-size: 14px;
  color: $color-black-2;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.content .company:not(.is-active):hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.content .is-active.company {
  background-color: $color-black-2;
  color: #fff;
}
.content .collapse {
  width: 100%;
}
.content .collapse .item {
  height: 60px;
  background-color: #F3F5F8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 0 22px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
}
.content .collapse .item .question {
  font-size: 24px;
  color: #3D3D3D;
}
.content .collapse .item .status {
  font-size: 16px;
  color: #3D3D3D;
}
.content .collapse .item .status .arrow {
  transition: all 0.4s linear;
  display: inline-block;
}
.content .collapse .item .status .rotateUp {
  transform: rotate(180deg);
}
.content .collapse .item .status .rotateDown {
  transform: rotate(0deg);
}
.content .collapse .item .status:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.content .collapse .item:after {
  display: block;
  content: '';
  width: 6px;
  height: 60px;
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  position: absolute;
  left: 0px;
  top: 0px;
}
.content .collapse .answer-box {
  background-color: #fff;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}
.content .collapse .answer-box .answer {
  padding: 28px 20px;
}
.content .btn-more {
  width: 214px;
  height: 44px;
  font-size: 16px;
  color: $color-black-2;
  border-color: $color-black-2;
}
.scroll-nav-affix-fixed {
  background-color: #fff;
  border-bottom: 1px solid #E5E7EB;
  padding-top: 7px;
}
.scroll-nav-affix-fixed .scroll-nav {
  margin-bottom: 0px;
}
.scroll-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -7px;
  padding-bottom: 6px;
}
</style>
